import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HStack } from "@chakra-ui/layout";
import ContactsTopActions from "../../contacts-top-actions/contacts-top-actions";
import AddContact from "../add-contact";
import CopyContactsFromList from "../copy-contacts-from-list";
const SingleContactTopActions = ({ isEditMode, contactListId, }) => (_jsxs(HStack, Object.assign({ spacing: { base: "2", md: "4" }, opacity: isEditMode ? 0.5 : 1 }, { children: [_jsx(CopyContactsFromList, { contactListId: contactListId }), _jsx(AddContact, { contactListId: contactListId }), _jsx(ContactsTopActions, { isSingleContact: true, contactListId: contactListId })] })));
export default SingleContactTopActions;
